module.exports = __webpack_public_path__ + "static/media/20.a5af3b5b.png";